export default {
	addProducts: "Add Products...",
	buildProductCriteria: "Build Product Criteria...",
	removeAllProducts: "Remove All Products...",
	parseProducts: "Batch pad add products...",
	parseProductsRemove: "Batch pad remove products...",
	addList: "Create List...",
	deleteList: "Delete List...",
	emailList: "Email List...",
	printList: "Print List...",
	printBarcodes: "Print Barcodes...",
	applyTags: "Apply Tags to List...",
	editCustomers: "Edit Customers...",
	editListSettings: "Edit List Settings...",
	applySortToProducts: "Apply Sort to Products...",
	hideGrade: true,
	hidePriceList: false,
	hideBarcode: true,
	hideInactive: true,
	useMultiPriceList: false
};
